export const assetPath = (path) => {
  return 'assets/' + path;
};

export const assetDir = 'assets';

export const modalDir = 'modals';
